import React from 'react';
import Link from 'next/link';
import { DialogContent, DialogHeader, DialogTitle, DialogDescription } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { COMMUNITY_GUIDELINES } from '@/lib/constants/community-guidelines';

export interface ContentModerationDialogProps {
    title: string;
    validationType?: 'insufficient_content' | 'inappropriate_content';
    customMessage: string;
    onEdit?: () => void;
    editButtonText?: string;
    onViewSuggestions: () => void;
    hasSuggestions: boolean;
    showSuggestionsButton: boolean;
    showGuideline?: boolean
}

export function ContentModerationDialog({
    title,
    validationType,
    customMessage,
    onEdit,
    editButtonText,
    onViewSuggestions,
    hasSuggestions,
    showSuggestionsButton, showGuideline = true
}: ContentModerationDialogProps) {
    return (
        <DialogContent className={'z-50'}>
            <DialogHeader>
                <DialogTitle>{title}</DialogTitle>
                <DialogDescription>
                    {customMessage}
                    {validationType === 'inappropriate_content' && showGuideline && (
                        <>
                            <br />
                            Please revise your content to meet our{' '}
                            <Link
                                href={COMMUNITY_GUIDELINES.LINK}
                                className="text-mixus-deep-blue hover:underline"
                                target="_blank"
                            >
                                community guidelines
                            </Link>
                            .
                        </>
                    )}
                </DialogDescription>
            </DialogHeader>
            <div className="flex justify-end space-x-2">
                { editButtonText &&  <Button
                    variant="outline"
                    onClick={onEdit}
                >
                    {editButtonText}
                </Button> }
                {showSuggestionsButton && (
                    <Button
                        onClick={onViewSuggestions}
                        disabled={!hasSuggestions}
                    >
                        View Suggestions
                    </Button>
                )}
            </div>
        </DialogContent>
    );
}
